import * as dates from 'react-big-calendar/lib/utils/dates'


export function inRange(e, start, end, accessors) {
    var eStart = dates.startOf(accessors.start(e), 'day');
    var eEnd = accessors.end(e);
    var startsBeforeEnd = dates.lte(eStart, end, 'day'); // when the event is zero duration we need to handle a bit differently
    var endsAfterStart = dates.gte(eEnd, start, 'minutes');
    return startsBeforeEnd && endsAfterStart;
  }
